export const teamMembers = [
  {
    id: 1,
    name: "Murat Yıldırım",
    title: "Kurucu",
    image: "/images/template_head.jpg",
    linkedin: "#",
    featured: true,
  },
  {
    id: 2,
    name: "Ömer Atay",
    title: "Genel Müdür",
    image: "/images/template_head.jpg",
    linkedin: "https://www.linkedin.com/in/%C3%B6mer-atay-910149194/",
    featured: true,
  },
  {
    id: 3,
    name: "Fuat Tekin",
    title: "İnşaat Mühendisi",
    image: "/images/template_head.jpg",
    linkedin: "#",
    featured: false,
  },
  {
    id: 6,
    name: "Caner Arifoğlu",
    title: "IT Yöneticisi",
    image: "/images/template_head.jpg",
    linkedin: "https://www.linkedin.com/in/caner-arifoglu-072693b8/",
    featured: false,
  },
  {
    id: 7,
    name: "Resul Dilmaç",
    title: "Formen",
    image: "/images/template_head.jpg",
    linkedin: "#",
    featured: false,
  },
];
